import { createRemoteComponent } from '@remote-ui/core';

const DropZone = createRemoteComponent('DropZone');

export { DropZone };
